<template>
  <v-app id="app">
    <!-- <v-navigation-drawer v-model="drawer" right temporary absolute>
      <v-list nav dense>
        <v-list-item-group active-class="deep-purple--text text--accent-4">
          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Account</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer> -->
    <Header v-if="$store.state.hasMounted" v-on:drawerClicked="drawer = !drawer"/>
    <v-content v-if="$store.state.hasMounted">
      <Banner v-if="toggles.toggleBanner"/>
      <Alerts v-if="toggles.toggleAlert" :label="labels.alertText"/>
      <News v-if="toggles.toggleNews" :label="labels.newsHeading"/>
      <YourCouncilUpdates v-if="toggles.toggleUpdates" :label="labels.updatesHeading"/>
      <FAQ v-if="toggles.toggleFAQ" :label="labels.faqHeading"/>
      <RegionalAreaUpdates v-if="toggles.toggleMap && $store.getters.getMapData && mapDataGot" :label="labels.mapHeading"/>
      <PublicAdvice v-if="toggles.toggleMapList" :label="labels.mapListHeading"/>
      <GovernmentResources v-if="toggles.toggleResources" :label="labels.resourcesHeading"/>
      <GovernmentUpdates v-if="toggles.toggleExternalFeed" :label="labels.externalFeedHeading"/>
      <SocialUpdates v-if="toggles.toggleSocialUpdates" :label="labels.socialUpdatesHeading"/>
    </v-content>
    <Footer v-if="$store.state.hasMounted"/>
  </v-app>
</template>

<script>
import Header from './components/Header.vue';
import Banner from './components/Banner.vue';
import YourCouncilUpdates from './components/YourCouncilUpdates.vue';
import GovernmentUpdates from './components/GovernmentUpdates.vue';
import RegionalAreaUpdates from './components/RegionalAreaUpdates.vue';
import GovernmentResources from './components/GovernmentResources.vue';
import PublicAdvice from './components/PublicAdvice.vue';
import SocialUpdates from './components/SocialUpdates.vue';
import Footer from './components/Footer.vue';
import Alerts from './components/Alerts.vue';
import FAQ from './components/FAQ.vue';
import News from './components/News.vue';

import cssVars from 'css-vars-ponyfill';
import 'whatwg-fetch'

export default {
  props: {
    source: String,
  },
  components: {
    Header,
    Banner,
    YourCouncilUpdates,
    GovernmentUpdates,
    RegionalAreaUpdates,
    GovernmentResources,
    PublicAdvice,
    SocialUpdates,
    Footer,
    Alerts,
    FAQ,
    News
  },
  data: () => ({
    drawer: false,
    mapDataGot: false
  }),
  computed: {
    toggles() {
      return this.$store.getters.getToggles
    },
    labels() {
      return this.$store.getters.getLabels
    }
  },
  created() {
    cssVars();
    if(process.env.NODE_ENV === 'production') {
      this.$axios.get('/settings/client_vars')
      .then(response => {
        this.$store.commit('importStore', response.data)
        this.$axios.get(this.$store.state.client_vars.MAP)
          .then(responseMap => {
              this.$store.commit('mapData', responseMap.data)
              this.mapDataGot = true
          })
          .catch(error => console.log('Failed to get map data', error))
      })
      .catch(error => console.log('Failed to get client_vars', error))
    } else {
      this.$axios.get('JSON/CLIENT_VARS.json')
        .then(response => {
          this.$store.commit('importStore', response.data)
          this.$axios.get(this.$store.state.client_vars.MAP)
            .then(responseMap => {
                this.$store.commit('mapData', responseMap.data)
                this.mapDataGot = true
            })
            .catch(error => console.log('Failed to get map data', error))
        })
        .catch(error => console.log('Failed to get client_vars', error))
    }
  }
}
</script>

<style lang="scss">
  #app {
    font-family: 'Montserrat', sans-serif;
    background-color: rgb(247, 244, 241);
    color: var(--v-black-base);
    font-weight: 500;

    // Safari column height fix
    .col-12 {
      flex: 0 0 auto;
    }
  }

  section.container {
    padding-top: 0;
    padding-bottom: 0;
  }

  .v-application li a, .v-application p a {
    // display: inline-block;
    color: var(--v-black-base);
    transition: all .4s;

    &:hover {
      color: var(--v-anchor-base);
    }
  }

  * {
    word-break: break-word;
  }

  h3 {
    font-size: 21px;
    font-weight: 500;
  }

  h4 {
    font-size: 30px;
    font-weight: 600;
    margin-bottom: 15px;
  }

  ul {
    list-style: none;
    padding-left: 0!important;

    li {
      background: url('./assets/icons/arrow-blue.svg') 0 5px no-repeat;
      background-size: 7px 12px;
      padding-left: 22px;
      margin-bottom: 12px;
    }
  }

  // Vuetify overrides 
  .v-card:not(.v-sheet--tile):not(.v-card--shaped) {
    border-radius: 0;
  }

  .theme--light.v-card.v-card--outlined {
    border: solid 1px #dedede;

    &.v-card__borders-govt {

      &--left {
        border-left-color: var(--v-govt-base)!important;
        border-left-style: solid;
        border-left-width: 8px;
      }

      &--right {
        border-right-color: var(--v-govt-base)!important;
        border-right-style: solid;
        border-right-width: 8px;
      }

      &--bottom {
        border-bottom-color: var(--v-govt-base)!important;
        border-bottom-style: solid;
        border-bottom-width: 8px;
      }
    
      &--top {
        border-top-color: var(--v-govt-base)!important;
        border-top-style: solid;
        border-top-width: 10px;
      }
    }

    &.v-card__borders-local {

      &--left {
        border-left-color: var(--v-local-base)!important;
        border-left-style: solid;
        border-left-width: 8px;
      }

      &--right {
        border-right-color: var(--v-local-base)!important;
        border-right-style: solid;
        border-right-width: 8px;
      }

      &--bottom {
        border-bottom-color: var(--v-local-base)!important;
        border-bottom-style: solid;
        border-bottom-width: 8px;
      }
    
      &--top {
        border-top-color: var(--v-local-base)!important;
        border-top-style: solid;
        border-top-width: 10px;
      }
    }

    &.v-card__borders-scdhb {
      &--left {
        border-left-color: var(--v-scdhb-base)!important;
        border-left-style: solid;
        border-left-width: 8px;
      }

      &--right {
        border-right-color: var(--v-scdhb-base)!important;
        border-right-style: solid;
        border-right-width: 8px;
      }

      &--bottom {
        border-bottom-color: var(--v-scdhb-base)!important;
        border-bottom-style: solid;
        border-bottom-width: 8px;
      }
    
      &--top {
        border-top-color: var(--v-scdhb-base)!important;
        border-top-style: solid;
        border-top-width: 10px;
      }
    }
  }
</style>
